module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Scott Heim\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("The author of two novels and a volume of poetry, Scott Heim has written for numerous publications, including "), _c('I', [_vm._v("The Advocate")]), _vm._v(", "), _c('I', [_vm._v("Village Voice")]), _vm._v(", and Nerve.com. He lives in Boston.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qhhAQZ/tc-custom/9780061737190.jpg?1731883397537",
      "alt": "This image is the cover for the book Mysterious Skin"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mysterious Skin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A disturbing incident sends two young boys down vastly different paths that reunite ten year later in this “impressive” debut novel ("), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("At the age of eight Brian Lackey is found bleeding under the crawl space of his house, having endured something so traumatic that he cannot remember an entire five–hour period of time. "), _c('br'), _c('br'), _vm._v("During the following years he slowly recalls details from that night, but these fragments are not enough to explain what happened to him, and he begins to believe that he may have been the victim of an alien encounter . . . "), _c('br'), _c('br'), _vm._v("Neil McCormick is fully aware of the events from that summer of 1981. Wise beyond his years, curious about his developing sexuality, Neil found what he perceived to be love and guidance from his baseball coach. Now, ten years later, he is a teenage hustler, unaware of the dangerous path his life is taking. His recklessness is governed by idealized memories of his coach, memories that unexpectedly change when Brian comes to Neil for help and, ultimately, the truth.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0